import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import { Error } from '../_models/auth.models';
import {
  CreateFormPayload,
  Form,
  FormData,
  FormDataField,
  FormField,
  FormID,
  TabData,
  UpdateFormPayload,
  PostDataSuccess as PostDataSuccessModel,
  PutDataSuccess as PutDataSuccessModel,
  PostDataBody,
  DeleteObjectSuccess as DeleteObjectSuccessModel,
  DeleteObject as DeleteObjectModel,
  PutDataBody,
  DependentRecords,
  DependentRecordsSuccess,
  UserDropDown,
  CopyFormPayload,
  CopyFormResponse,
  SyncDataResponse,
  SavedFields,
  SigningRequestResponse,
} from '../_models/form.model';
import { Dropdown } from '../_models/ignatius.models';
import { Dictionary } from '@ngrx/entity';

/**
 * Form action types
 */
export enum FormActionTypes {
  LOAD_FORM_FIELDS = '[Form] Load Form Fields',
  LOAD_FORM_FIELDS_SUCCESS = '[Form] Load Form Fields Success',
  LOAD_FORM_FIELDS_FAILED = '[Form] Load Form Fields Failed',
  CREATE_FORM = '[Form] Create Form',
  CREATE_FORM_SUCCESS = '[Form] Create Form Success',
  CREATE_FORM_FAILED = '[Form] Create Form Failed',
  LOAD_FORMS = '[Form] Load Forms',
  LOAD_FORMS_SUCCESS = '[Form] Load Forms Success',
  LOAD_FORMS_FAILED = '[Form] Load Forms Failed',
  LOAD_FORMS_BY_TABLES = '[Form] Load Forms By Tables',
  LOAD_FORMS_BY_TABLES_SUCCESS = '[Form] Load Forms By Tables Success',
  LOAD_FORMS_BY_TABLES_FAILED = '[Form] Load Forms By Tables Failed',
  LOAD_FORM = '[Form] Load Form',
  LOAD_FORM_SUCCESS = '[Form] Load Form Success',
  LOAD_FORM_FAILED = '[Form] Load Form Failed',
  UPDATE_FORM = '[Form] Update Form',
  UPDATE_FORM_SUCCESS = '[Form] Update Form Success',
  UPDATE_FORM_FAILED = '[Form] Update Form Failed',
  DELETE_FORM = '[Form] Delete Form',
  DELETE_FORM_SUCCESS = '[Form] Delete Form Success',
  DELETE_FORM_FAILED = '[Form] Delete Form Failed',
  LOAD_FORM_SAVED_FIELDS = '[Form] Load Form Saved Fields',
  LOAD_FORM_SAVED_FIELDS_SUCCESS = '[Form] Load Form Saved Fields Success',
  LOAD_FORM_SAVED_FIELDS_FAILED = '[Form] Load Form Saved Fields Failed',
  LOAD_FORM_RULES = '[Form] Load Form Rules',
  LOAD_FORM_RULES_SUCCESS = '[Form] Load Form Rules Success',
  LOAD_FORM_RULES_FAILED = '[Form] Load Form Rules Failed',
  LOAD_FORM_ID = '[Form] Load Form ID',
  LOAD_FORM_ID_SUCCESS = '[Form] Load Form ID Success',
  LOAD_FORM_ID_FAILED = '[Form] Load Form ID Failed',
  LOAD_FORM_DATA = '[Form] Load Form Data',
  LOAD_FORM_DATA_SUCCESS = '[Form] Load Form Data Success',
  LOAD_FORM_DATA_FAILED = '[Form] Load Form Data Failed',
  POST_DATA = '[Form] Post Data',
  POST_DATA_SUCCESS = '[Form] Post Data Success',
  POST_DATA_FAILED = '[Form] Post Data Failed',
  DELETE_OBJECT = '[Form] Delete Object',
  DELETE_OBJECT_SUCCESS = '[Form] Delete Object Success',
  DELETE_OBJECT_FAILED = '[Form] Delete Object Failed',
  PUT_DATA = '[Form] Put Data',
  PUT_DATA_SUCCESS = '[Form] Put Data Success',
  PUT_DATA_FAILED = '[Form] Put Data Failed',
  COPY_DATA = '[Form] Copy Data',
  COPY_DATA_SUCCESS = '[Form] Copy Data Success',
  COPY_DATA_FAILED = '[Form] Copy Data Failed',
  LOAD_DEPENDENT_RECORDS = '[Form] Load Dependent Records',
  LOAD_DEPENDENT_RECORDS_SUCCESS = '[Form] Load Dependent Records Success',
  LOAD_DEPENDENT_RECORDS_FAILED = '[Form] Load Dependent Records Failed',
  GET_FORM_FIELD_USERS = '[Form] Get Form Field Users',
  GET_FORM_FIELD_USERS_SUCCESS = '[Form] Get Form Field Users Success',
  GET_FORM_FIELD_USERS_FAILED = '[Form] Get Form Field Users Failed',
  SYNC_DATA = '[Form] Sync Data',
  SYNC_DATA_SUCCESS = '[Form] Sync Data Success',
  SYNC_DATA_FAILED = '[Form] Sync Data Failed',
  COPY_FORM = '[Form] Copy Form',
  COPY_FORM_SUCCESS = '[Form] Copy Form Success',
  COPY_FORM_FAILED = '[Form] Copy Form Failed',
  GET_RELATED_DATA = '[Form] Get Related Data',
  GET_RELATED_DATA_SUCCESS = '[Form] Get Related Data Success',
  GET_RELATED_DATA_FAILED = '[Form] Get Related Data Failed',
  GET_SIGNING_REQUEST_DATA = '[Form] Get Signing Request Data',
  GET_SIGNING_REQUEST_DATA_SUCCESS = '[Form] Get Signing Request Data Success',
  GET_SIGNING_REQUEST_DATA_FAILED = '[Form] Get Signing Request Data Failed',
  GET_SIGNING_DOCUMENT_DATA = '[Form] Get Signing Document Data',
  GET_SIGNING_DOCUMENT_DATA_SUCCESS = '[Form] Get Signing Document Data Success',
  GET_SIGNING_DOCUMENT_DATA_FAILED = '[Form] Get Signing Document Data Failed',
  SEND_DOCUMENT_CONFIRMATION = '[Form] Send Document Confirmation',
  SEND_DOCUMENT_CONFIRMATION_SUCCESS = '[Form] Send Document Confirmation Success',
  SEND_DOCUMENT_CONFIRMATION_FAILED = '[Form] Send Document Confirmation Failed',
  GET_SVG_DATA = '[Form] Get SVG Data',
  GET_SVG_DATA_SUCCESS = '[Form] Get SVG Data Success',
  GET_SVG_DATA_FAILED = '[Form] Get SVG Data Failed',
  RESET = '[Form] RESET',
  RESET_FORM_RULE = '[Form] RESET_FORM_RULE',
  RESET_RELATED_DATA = '[Form] RESET_RELATED_DATA',
}

/**
 * Operations
 */
export class LoadFormFields implements Action {
  readonly type = FormActionTypes.LOAD_FORM_FIELDS;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public tableId: string, public force: boolean = false) {}
}

export class LoadFormFieldsSuccess implements Action {
  readonly type = FormActionTypes.LOAD_FORM_FIELDS_SUCCESS;

  constructor(public tableId: string, public payload: Array<FormField>) {}
}

export class LoadFormFieldsFailed implements Action {
  readonly type = FormActionTypes.LOAD_FORM_FIELDS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class CreateForm extends Reference implements Action {
  readonly type = FormActionTypes.CREATE_FORM;

  constructor(public payload: CreateFormPayload) {
    super();
  }
}

export class CreateFormSuccess extends Reference implements Action {
  readonly type = FormActionTypes.CREATE_FORM_SUCCESS;

  constructor(public payload: object) {
    super();
  }
}

export class CreateFormFailed extends Reference implements Action {
  readonly type = FormActionTypes.CREATE_FORM_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadForms implements Action {
  readonly type = FormActionTypes.LOAD_FORMS;

  constructor(public tableId: string,public isFromReport:boolean = false) {}
}
export class LoadFormsSuccess implements Action {
  readonly type = FormActionTypes.LOAD_FORMS_SUCCESS;

  constructor(public tableId: string, public payload: Array<Form>) {}
}

export class LoadFormsFailed implements Action {
  readonly type = FormActionTypes.LOAD_FORMS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}


export class LoadFormsByTables implements Action {
  readonly type = FormActionTypes.LOAD_FORMS_BY_TABLES;

  constructor(public tableIds: Array<string>, public tableId: string) {}
}
export class LoadFormsByTablesSuccess implements Action {
  readonly type = FormActionTypes.LOAD_FORMS_BY_TABLES_SUCCESS;
  constructor(
    public payload: Dictionary<Array<Form>>,
    public tableId: string
  ) {}
}

export class LoadFormsByTablesFailed implements Action {
  readonly type = FormActionTypes.LOAD_FORMS_BY_TABLES_FAILED;

  constructor(public payload: Error, public tableIds: Array<string>) {}
}

export class LoadForm implements Action {
  readonly type = FormActionTypes.LOAD_FORM;

  constructor(public tableId: string, public formId: string) {}
}

export class LoadFormSuccess implements Action {
  readonly type = FormActionTypes.LOAD_FORM_SUCCESS;

  constructor(
    public tableId: string,
    public formId: string,
    public payload: Form
  ) {}
}

export class LoadFormFailed implements Action {
  readonly type = FormActionTypes.LOAD_FORM_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class UpdateForm extends Reference implements Action {
  readonly type = FormActionTypes.UPDATE_FORM;

  constructor(
    public tableId: string,
    public formId: string,
    public payload: UpdateFormPayload
  ) {
    super();
  }
}

export class UpdateFormSuccess extends Reference implements Action {
  readonly type = FormActionTypes.UPDATE_FORM_SUCCESS;

  constructor(public tableId: string, public formId: string) {
    super();
  }
}

export class UpdateFormFailed extends Reference implements Action {
  readonly type = FormActionTypes.UPDATE_FORM_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class DeleteForm extends Reference implements Action {
  readonly type = FormActionTypes.DELETE_FORM;

  constructor(public tableId: string, public formId: string) {
    super();
  }
}

export class DeleteFormSuccess extends Reference implements Action {
  readonly type = FormActionTypes.DELETE_FORM_SUCCESS;

  constructor(public tableId: string, public formId: string) {
    super();
  }
}

export class DeleteFormFailed extends Reference implements Action {
  readonly type = FormActionTypes.DELETE_FORM_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadFormSavedFields implements Action {
  readonly type = FormActionTypes.LOAD_FORM_SAVED_FIELDS;

  constructor(
    public tableId: string,
    public formId: string,
    public defualtForm: boolean = true,
    public fromEmbeddedOrDrilldown: boolean = false,
    public parentTableId: string = '0',
    public reportId:string | null = null
  ) {}
}

export class LoadFormSavedFieldsSuccess implements Action {
  readonly type = FormActionTypes.LOAD_FORM_SAVED_FIELDS_SUCCESS;

  constructor(
    public tableId: string,
    public formId: string,
    public payload: SavedFields
  ) {}
}

export class LoadFormSavedFieldsFailed implements Action {
  readonly type = FormActionTypes.LOAD_FORM_SAVED_FIELDS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class LoadFormRules implements Action {
  readonly type = FormActionTypes.LOAD_FORM_RULES;

  constructor(
    public formId: string,
    public tableId: string,
  ) {}
}

export class LoadFormRulesSuccess implements Action {
  readonly type = FormActionTypes.LOAD_FORM_RULES_SUCCESS;

  constructor(
    public formId: string,
    public tableId: string,
    public payload: any
  ) {}
}

export class LoadFormRulesFailed implements Action {
  readonly type = FormActionTypes.LOAD_FORM_RULES_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class LoadFormID implements Action {
  readonly type = FormActionTypes.LOAD_FORM_ID;

  constructor(
    public tableId: string,
    public reportId: string,
    public isPDF: boolean = false
  ) {}
}

export class LoadFormIDSuccess implements Action {
  readonly type = FormActionTypes.LOAD_FORM_ID_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public payload: FormID
  ) {}
}

export class LoadFormIDFailed implements Action {
  readonly type = FormActionTypes.LOAD_FORM_ID_FAILED;

  constructor(public payload: Error) {}
}

export class LoadFormData extends Reference implements Action {
  readonly type = FormActionTypes.LOAD_FORM_DATA;

  constructor(
    public tableId: string,
    public formId: string,
    public recordId: number,
    public forProcess: boolean = false,
    public forRecordView: boolean = false,
  ) {
    super();
  }
}

export class LoadFormDataSuccess extends Reference implements Action {
  readonly type = FormActionTypes.LOAD_FORM_DATA_SUCCESS;

  constructor(
    public tableId: string,
    public formId: string,
    public recordId: number,
    public forProcess: boolean = false,
    public payload: Array<FormDataField>
  ) {
    super();
  }
}

export class LoadFormDataFailed extends Reference implements Action {
  readonly type = FormActionTypes.LOAD_FORM_DATA_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class PostData extends Reference implements Action {
  readonly type = FormActionTypes.POST_DATA;

  constructor(public applicationTableId: string, public payload: PostDataBody) {
    super();
  }
}

export class PostDataSuccess extends Reference implements Action {
  readonly type = FormActionTypes.POST_DATA_SUCCESS;

  constructor(
    public applicationTableId: string,
    public payload: PostDataSuccessModel
  ) {
    super();
  }
}

export class PostDataFailed extends Reference implements Action {
  readonly type = FormActionTypes.POST_DATA_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class CopyData extends Reference implements Action {
  readonly type = FormActionTypes.COPY_DATA;

  constructor(public applicationTableId: string, public recordId: string, public payload: any) {
    super();
  }
}

export class CopyDataSuccess extends Reference implements Action {
  readonly type = FormActionTypes.COPY_DATA_SUCCESS;

  constructor(
    public applicationTableId: string,
    public recordId: string,
    public payload:any
  ) {
    super();
  }
}

export class CopyDataFailed extends Reference implements Action {
  readonly type = FormActionTypes.COPY_DATA_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class DeleteObject extends Reference implements Action {
  readonly type = FormActionTypes.DELETE_OBJECT;

  constructor(public payload: DeleteObjectModel) {
    super();
  }
}

export class DeleteObjectSuccess extends Reference implements Action {
  readonly type = FormActionTypes.DELETE_OBJECT_SUCCESS;

  constructor(
    public applicationTableId: string,
    public payload: DeleteObjectSuccessModel
  ) {
    super();
  }
}

export class DeleteObjectFailed extends Reference implements Action {
  readonly type = FormActionTypes.DELETE_OBJECT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class PutData extends Reference implements Action {
  readonly type = FormActionTypes.PUT_DATA;

  constructor(
    public recordId: number,
    public applicationTableId: string,
    public payload: any
  ) {
    super();
  }
}

export class PutDataSuccess extends Reference implements Action {
  readonly type = FormActionTypes.PUT_DATA_SUCCESS;

  constructor(
    public recordId: number,
    public applicationTableId: string,
    public payload: PutDataSuccessModel
  ) {
    super();
  }
}

export class PutDataFailed extends Reference implements Action {
  readonly type = FormActionTypes.PUT_DATA_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadDependentRecords implements Action {
  readonly type = FormActionTypes.LOAD_DEPENDENT_RECORDS;

  constructor(
    public tableId: string,
    public id: string,
    public payload: DependentRecords
  ) {}
}

export class LoadDependentRecordsSuccess implements Action {
  readonly type = FormActionTypes.LOAD_DEPENDENT_RECORDS_SUCCESS;

  constructor(
    public tableId: string,
    public id: string,
    public payload: DependentRecordsSuccess
  ) {}
}

export class LoadDependentRecordsFailed implements Action {
  readonly type = FormActionTypes.LOAD_DEPENDENT_RECORDS_FAILED;

  constructor(public payload: Error) {}
}

export class GetFormFieldUsers implements Action {
  readonly type = FormActionTypes.GET_FORM_FIELD_USERS;

  constructor(
    public tableId: string,
    public applicationId: string,
    public formId: string,
    public fieldId: string,
    public isSearch: boolean,
    public search: string,
    public isScroll: boolean,
    public skip: number,
    public pageSize: number,
    public isConditionComponent: boolean,
    public fromSMSNotification: boolean = false
  ) {}
}

export class GetFormFieldUsersSuccess implements Action {
  readonly type = FormActionTypes.GET_FORM_FIELD_USERS_SUCCESS;

  constructor(
    public tableId: string,
    public applicationId: string,
    public formId: string,
    public fieldId: string,
    public payload: Array<UserDropDown>
  ) {}
}

export class GetFormFieldUsersFailed implements Action {
  readonly type = FormActionTypes.GET_FORM_FIELD_USERS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class GetRelatedData extends Reference implements Action {
  readonly type = FormActionTypes.GET_RELATED_DATA;

  constructor(
    public tableId: string,
    public fieldId: string,
    public dropdownLabel: string,
    public isSearch: boolean,
    public search: string,
    public isScroll: boolean,
    public skip: number,
    public pageSize: number,
    public isConditionComponent: boolean,
    public relatedValue?: number,
    public relatedFieldName?: string,
    public relatedConditions?: any,
    public selectedValue: any = null,
  ) {
    super();
  }
}

export class GetRelatedDataSuccess extends Reference implements Action {
  readonly type = FormActionTypes.GET_RELATED_DATA_SUCCESS;

  constructor(
    public tableId: string,
    public fieldId: string,
    public payload: Array<Dropdown>
  ) {
    super();
  }
}

export class GetRelatedDataFailed extends Reference implements Action {
  readonly type = FormActionTypes.GET_RELATED_DATA_FAILED;

  constructor(public payload: Error, public tableId: string) {
    super();
  }
}

export class Reset implements Action {
  readonly type = FormActionTypes.RESET;

  constructor() {}
}

export class ResetFormRule implements Action {
  readonly type = FormActionTypes.RESET_FORM_RULE;

  constructor() {}
}

export class ResetRelatedData implements Action {
  readonly type = FormActionTypes.RESET_RELATED_DATA;

  constructor() {}
}

export class SyncData extends Reference implements Action {
  readonly type = FormActionTypes.SYNC_DATA;

  constructor(public applicationTableId: string, public payload: any) {
    super()
  }
}

export class CopyForm extends Reference implements Action {
  readonly type = FormActionTypes.COPY_FORM;

  constructor(public tableId: string, public payload: CopyFormPayload) {
    super();
  }
}

export class SyncDataSuccess extends Reference implements Action {
  readonly type = FormActionTypes.SYNC_DATA_SUCCESS;

  constructor(
    public applicationTableId: string,
    public payload: SyncDataResponse
  ) {
    super()
  }
}

export class CopyFormSuccess extends Reference implements Action {
  readonly type = FormActionTypes.COPY_FORM_SUCCESS;

  constructor(public payload: CopyFormResponse) {
    super();
  }
}

export class SyncDataFailed extends Reference implements Action {
  readonly type = FormActionTypes.SYNC_DATA_FAILED;

  constructor(public payload: Error) {
    super()
  }
}

export class CopyFormFailed extends Reference implements Action {
  readonly type = FormActionTypes.COPY_FORM_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class GetSigningRequestData implements Action {
  readonly type = FormActionTypes.GET_SIGNING_REQUEST_DATA;

  constructor(
    public tableId: string,
    public recordId: number,
    public fieldId: string
  ) {}
}

export class GetSigningRequestDataSuccess implements Action {
  readonly type = FormActionTypes.GET_SIGNING_REQUEST_DATA_SUCCESS;

  constructor(
    public tableId: string,
    public recordId: number,
    public fieldId: string,
    public payload: SigningRequestResponse
  ) {}
}

export class GetSigningRequestDataFailed implements Action {
  readonly type = FormActionTypes.GET_SIGNING_REQUEST_DATA_FAILED;

  constructor(public payload: Error) {}
}

export class GetSigningDocumentData implements Action {
  readonly type = FormActionTypes.GET_SIGNING_DOCUMENT_DATA;

  constructor(
    public tableId: string,
    public recordId: number,
    public fieldId: string
  ) {}
}

export class GetSigningDocumentDataSuccess implements Action {
  readonly type = FormActionTypes.GET_SIGNING_DOCUMENT_DATA_SUCCESS;

  constructor(
    public tableId: string,
    public recordId: number,
    public fieldId: string,
    public payload: SigningRequestResponse
  ) {}
}

export class GetSigningDocumentDataFailed implements Action {
  readonly type = FormActionTypes.GET_SIGNING_DOCUMENT_DATA_FAILED;

  constructor(public payload: Error) {}
}

export class SendDocumentConfirmation implements Action {
  readonly type = FormActionTypes.SEND_DOCUMENT_CONFIRMATION;

  constructor(
    public tableId: string,
    public recordId: number,
    public fieldId: string,
    public documentId: string
  ) {}
}

export class SendDocumentConfirmationSuccess implements Action {
  readonly type = FormActionTypes.SEND_DOCUMENT_CONFIRMATION_SUCCESS;

  constructor(
    public tableId: string,
    public recordId: number,
    public fieldId: string,
    public documentId: string,
    public payload: any
  ) {}
}
export class SendDocumentConfirmationFailed implements Action {
  readonly type = FormActionTypes.SEND_DOCUMENT_CONFIRMATION_FAILED;

  constructor(public payload: Error) {}
}
export class GetSVGData implements Action {
  readonly type = FormActionTypes.GET_SVG_DATA;

  constructor(public svgNames: any[]) {}
}

export class GetSVGDataSuccess implements Action {
  readonly type = FormActionTypes.GET_SVG_DATA_SUCCESS;

  constructor(
    public tableId: string,
    public recordId: number,
    public fieldId: string,
    public svgNames: any,
    public payload: any
  ) {}
}
export class GetSVGDataFailed implements Action {
  readonly type = FormActionTypes.GET_SVG_DATA_FAILED;

  constructor(public payload: Error) {}
}

/**
 * Available types
 */
export type Actions =
  | LoadFormFields
  | LoadFormFieldsSuccess
  | LoadFormFieldsFailed
  | CreateForm
  | CreateFormSuccess
  | CreateFormFailed
  | LoadForms
  | LoadFormsSuccess
  | LoadFormsFailed
  | LoadFormsByTables
  | LoadFormsByTablesSuccess
  | LoadFormsByTablesFailed
  | LoadForm
  | LoadFormSuccess
  | LoadFormFailed
  | UpdateForm
  | UpdateFormSuccess
  | UpdateFormFailed
  | DeleteForm
  | DeleteFormSuccess
  | DeleteFormFailed
  | LoadFormID
  | LoadFormIDSuccess
  | LoadFormIDFailed
  | LoadFormSavedFields
  | LoadFormSavedFieldsSuccess
  | LoadFormSavedFieldsFailed
  | LoadFormRules
  | LoadFormRulesSuccess
  | LoadFormRulesFailed
  | LoadFormData
  | LoadFormDataSuccess
  | LoadFormDataFailed
  | PostData
  | PostDataSuccess
  | PostDataFailed
  | CopyData
  | CopyDataSuccess
  | CopyDataFailed
  | DeleteObject
  | DeleteObjectSuccess
  | DeleteObjectFailed
  | PutData
  | PutDataSuccess
  | PutDataFailed
  | SyncData
  | SyncDataSuccess
  | SyncDataFailed
  | LoadDependentRecords
  | LoadDependentRecordsSuccess
  | LoadDependentRecordsFailed
  | GetFormFieldUsers
  | GetFormFieldUsersSuccess
  | GetFormFieldUsersFailed
  | GetSigningRequestData
  | GetSigningRequestDataSuccess
  | GetSigningRequestDataFailed
  | GetSigningDocumentData
  | GetSigningDocumentDataSuccess
  | GetSigningDocumentDataFailed
  | SendDocumentConfirmation
  | SendDocumentConfirmationSuccess
  | SendDocumentConfirmationFailed
  | CopyForm
  | CopyFormSuccess
  | CopyFormFailed
  | GetRelatedData
  | GetRelatedDataSuccess
  | GetRelatedDataFailed
  | GetSVGData
  | GetSVGDataSuccess
  | GetSVGDataFailed
  | Reset
  | ResetFormRule
  | ResetRelatedData;
